

import React from "react";
// import "./ForexPage.css";
import "../style/CommoditiesTrading.css";

const CommoditiesTrading = () => {




  return (
    <div className="Commodities-container">
      {/* Hero Section */}
      <section className="Commodities-hero">
        <h1>Commodities Trading</h1>
        <p>
         <span>Commodity trading is the buying and selling of a wide range of</span><br/>
         <span>commodities such as energy, metals, oil, gas and agricultural products.</span>
        </p>
      </section>
      <br/><br/>

      {/* Why Trade Forex */}
      <div className="commodities">
      <h2 id="Commodities">Trade Commodities with Extrede</h2>
      <section className="commodities-why-trade">
        
          <div className="commodities-text1">
                Trading commodities CFDs (“contracts for difference”) is a great way to diversify your portfolio and hedge risks. Extrede has carved a niche for itself in the commodity trading market in Australia, offering the optimal trading experience.<br/><br/>

                Choosing from an extensive portfolio of financial products, while benefiting from the latest real-time technology and available commodity prices. When you choose to trade commodity CFDs, you get access to commodity prices worldwide with high execution speeds, low slippage, deep liquidity and tight spreads.<br/><br/>

                Trade in CFDs on a wide range of universal commodities, including gold (XAU), silver (XAG) and oil (CL, WTI) with a regulated broker provider giving you access to different asset classes, sophisticated risk management and trading tools.
          </div>

          <div className="commodities-text2">
            <h3>What are the benefits of commodities trading?</h3>
            <ul>
              <li><i class="fa-solid fa-check"></i>Leverage up to 500:1</li><br/>
              <li><i class="fa-solid fa-check"></i>Choose from a wide range of commodities, such as energy, metals and agricultural products</li><br/>
              <li><i class="fa-solid fa-check"></i>Enter and exit trades whenever you want to 24/5</li><br/>
              <li><i class="fa-solid fa-check"></i>Trade in any direction you think the markets will go. Sell and go short or buy to go long, maximizing trading opportunities and minimizing risks.</li><br/>
              <li><i class="fa-solid fa-check"></i>No price manipulation</li><br/>
              <li><i class="fa-solid fa-check"></i>Hedge Risks – Hedge your investment risks with high-value assets, like gold (XAU), silver (XAG), and Oil (WTI / CL)</li><br/>
              <li><i class="fa-solid fa-check"></i>Benefit from low margin, low-cost trading, without compromising execution</li>
            
              
            </ul>
          </div>
      </section>
      </div>

      <br/><br/>
      <div className="market">
        <h1>WATCH  MARKET</h1>
      </div>

      <div className="commodities">
      <h2 id="Commodities">The Top Ten Commodities to Trade</h2>
      <section className="commodities-why-trade">
        
        <div className="commodities-text1">
            Commodities are essentially the raw materials from which other goods are created; the basic building blocks of the global economy. Consequently, they often serve as an excellent investment vehicle. Commodities fall into two broad categories: hard commodities and soft commodities.<br/><br/>

            Hard commodities are those that are mined from the earth or extracted from natural resources. This category includes metals such as gold, silver and iron, and energies such as oil, natural gas and coal. Soft commodities are agricultural products such as livestock and crops. The commodity markets are popular among traders. This is because they are highly volatile, a feature that provides traders with greater opportunities for success. What separates commodities from other goods is the fact they are interchangeable and standardised, with their values set by the relevant commodity exchange.<br/><br/>

            However, when it comes to commodities trading, not all commodities are equal.
        </div>

        <div className="commodities-text2">
          <p>Some are better than others. With a wide range of commodities on the market, it’s important to know what makes a commodity good for trading.</p>
         <ul>
            <li><i id="black" class="fa-solid fa-circle"></i>Crude Oil</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Gold</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Sliver</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Platinum and Palladium</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Base Metals: Copper, Iron, Steel, Aluminium</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Coffee</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Natural Gas</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Soya Beans</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Corn</li><br/>
            <li><i id="black" class="fa-solid fa-circle"></i>Wheat</li><br/>
         </ul>
        </div>
    </section>
    </div>



    <section className="comm-best-platform">
      <h2 >What Makes a Good<br/>
             Trading Commodity?</h2>
        <div className="content1">
            <div className="image-container">
                <img src="/images/comdity1.png" alt="Trading Platform" />
            </div>
          <div className="text-content1">
            
            <p >When trading commodities, liquidity is the primary thing you should consider. This is because liquidity determines the ease with which you can sell or buy a commodity. A liquid market is generally associated with relatively lower risk as there will likely be someone willing to take the other side of a trading position. A good commodity will usually have a well-established market of buyers and sellers at any given time.</p>
            <br/><br/>
            <p  >Highly liquidity also means that a commodity will have less risk of slippage. Slippage refers to the losses that occur when bid-offer spreads are wide and it’s a common occurrence among commodities that exhibit low degrees of liquidity. Liquidity differentiates the most-traded commodities from the rest of the flock. This leads us to an all-important question.</p>
          </div>
          
        </div>
       </section>

      <br/><br/>


      <section  id="good11" className="comm-best-platform">
      <h2 id="good">What is the Best Platform to Trade Forex?</h2>
        <div className="content1">
          <div id="good" className="text-content1">
            
            <p  id="good">Discover the benefits of Forex trading on one of the most powerful trading platforms available, extrede 5 (extrede 5). Available across desktop and mobile platforms, the MetaTrader 5 platform is ready when you are.</p>
            <ul >
              <li id="good">Spreads from 0.0 pips & leverage up to 500:1</li>
              <li id="good">Customisable interface, including colours of technical indicators</li>
              <li id="good">One-click trading</li>
              <li id="good">MarketWatch</li>
              <li id="good">Live price streaming on Live accounts and Demo accounts 128-bits encryption for secure trading</li>
              <li id="good">Expert Advisors (EAs)</li>
              <li id="good">Customisable alerts</li>
              <li id="good">Compatible with iOS, Android, and Mac devices</li>
            </ul>
          </div>
          <div className="image-container">
            <img src="/images/foreex1.png" alt="Trading Platform" />
          </div>
        </div>
       </section>

      <br/><br/>



 



      {/* 6 Reasons Section */}
      <section className="comm-reasons">
        <h2>6 Reasons to Choose extrede   </h2>
        <h4>A Global Forex Broker</h4>

        <div className="comm-grid">

          <div className="comm-card">
          <span className="icon">⚖️</span>
            <h2>Global Regulated Broker</h2>
            <p>Boost your trading experience with a licensed and fully regulated Global comm broker, with multiple awards to their name.</p>
          </div>

          <div className="comm-card">
          <span className="icon">📱</span>
            <h2>Trading Platforms</h2>
            <p>Give your comm trading an edge with robust, feature-rich and easy-to-use MetaTrader 4, MetaTrader 5 and Iress.</p>
          </div>



          <div className="comm-card">
          <span className="icon">⚡</span>
            <h2>Low Latency Execution</h2>
            <p>Get all the available market prices and tight spreads, with ultra-low latency execution and minimal slippage.
            </p>
          </div>
          <div className="comm-card">
          <span className="icon">📈</span>
            <h2>Forex Trading Leverage</h2>
            <p>Leverage of up to 500:1 in over 50 currency pairs and widen your exposure to the global comm markets</p>
          </div>
        </div>
          
      </section>


      <section className="comm-best-platform">
      <h2>What is Commodities Trading?</h2>
        <div className="content1">
            <div className="image-container">
                <img src="/images/comdity2.png" alt="Trading Platform" />
            </div>
          <div className="text-content1">
            
            <p>Commodities trading represents the buying and selling of quantity sets of homogeneous and near-homogeneous assets. Popular commodities include the West Texas Intermediate (WTI), Brent Crude Oil (XTI), Gold (XAU) and other precious metals, and soft commodities such as Wheat, Coffee, Cocoa, Soya etc. Price movements in commodities are relatively slow and are usually seen as bellwethers and market indicators for the overall health of the industry that produces and consumes them.</p>
            <br/><br/>
            <p>Commodity prices can be impacted by various factors, including adverse weather and seasonal availability, natural disasters, severe climate changes and other non-market factors generally found in other financial instruments. Typically, trading in commodities can be either speculative or for hedging purposes. Traders can trade commodity markets to express their outlook on certain industries, or to hedge their trading portfolio by taking an opposite position in a commodity to offset potential losses Hedging as a risk management strategy has its purpose to minimize potential losses but could also result in reducted returns.</p>
          </div>
          
        </div>
       </section>
       <br/><br/><br/>

       <section id="broker" className="comm-best-platform">
        <h2 id="trade">Forex Trading Example</h2>
        <div className="content1">

          <div className="text-content1">
            <h3>Example of Leveraged
            CFD Commodities Trading</h3><br/>
            {/* <p>Where the underlying asset is the AUD/USD currency pair, also known as the “Aussie.” Let us suppose that the AUD/USD pair is trading at:</p> */}
            <p>Suppose you want to trade CFDs, where the underlying asset is the XTIUSD a commodity, also known as Crude Oil. Let us suppose that the XTIUSD is trading at:</p>
          </div>

          <div className="image-container">
            <img src="/images/forex3.png" alt="Trading Platform" />
          </div> 
        </div>
      </section>

      <br/><br/><br/><br/><br/><br/>

      <section id="red" className="comm-best-platform">
        
        <div className="content1">

          <div className="text-content1">
            <p>You decide to buy 2,000 barrels of XTIUSD because you think that the XTIUSD price will rise in the future. Your margin rate is 1%. This means that you need to deposit 1% of the total position value into your margin account.</p>
            <br/>
            <div className="image-container">
            <img src="/images/comdity3.png" alt="Trading Platform" />
            </div>
          </div>

          <div className="image-container">
           <p id="clrblackk">Now, in the next hour, if the price moves to 83.10/83.11, you have a winning trade. You could close your position by selling at the current price of USD 83.10</p>
           <br/>
           <div className="image-container">
            <img src="/images/comdity4.png" alt="Trading Platform" />
            </div>
          </div> 
        </div>
      </section>

        
      <br/><br/><br/><br/><br/><br/>


      <section id="broker" className="comm-best-platform">
        
        <div className="content1">

          <div className="text-content1">
            <p>In this case, the price of crude oil moved in your favor. But, had the price declined instead, moving against your prediction, you could have made a loss. If that loss reduced your free equity to negative, your broker would have issued a margin call and will close all your trades if the equity falls at 50% of 1660.</p>
          </div>

          <div className="image-container">
            <img src="/images/comdity5.png" alt="Trading Platform" />
          </div> 
        </div>
      </section>

      <div className="image-container1">
            <img src="/images/comdity6.png" alt="Trading Platform" />
          </div> 

        <h2 id="soft">Soft Commodities</h2>
        <div className="image-container1">
            <img src="/images/comdity7.png" alt="Trading Platform" />
        </div> 
        
        <h2 id="soft">CFD Commodities </h2>
        <div className="image-container1">
            <img src="/images/comdity8.png" alt="Trading Platform" />
        </div> 



        
        <div id="comm" className="commodities">
      <h2 id="Commodities">Introduction to Commodities Markets</h2>
      <p id="para11">Learn more about major commodity markets</p>
      <section id="Commodities-Markets" className="commodities-why-trade">
        
          <div className="commodities-text1">
            <h2>Gold Markets</h2>
            <p>Throughout history, gold has always been seen as a valuable commodity, and for good reason. In addition to being an in-demand precious metal in many industries, gold is an ideal hedge for financial market risks, especially during periods of macroeconomic and geopolitical uncertainty. There is generally strong global market demand for gold making it one of the most actively traded commodities in the world.</p><br/><br/>
            <p>If you want to trade gold, there are several options open to you. You can directly invest in physical gold by purchasing gold bullion from bullion dealers or through gold exchange-traded funds (ETFs) that hold the commodity. Alternatively, you can trade gold through ETFs that track the movements of the commodity or purchase gold CFDs (contracts for difference) which track the asset’s underlying price. The latter is one of the most popular ways of trading gold and it’s quite easy to see why when you know how trading gold CFDs works.</p><br/><br/>
            <h2>Wheat Markets</h2>
            <p>Wheat is one of the most important food components and is cultivated globally. This grain has always piqued investors’ interests because it allows them to participate in the agricultural markets by trading wheat CFDs without holding actual tons of it. Wheat commodity trading can take place on several exchanges but there are two main that are listed in wheat futures: Chicago Board of Trade and NYSE Euronext. Wheat futures prices are quoted in USD and cents (USD) per bushel.</p><br/><br/>
            <p>The countries producing the biggest quantity of wheat are the European Union with 152,000 thousand metric tons annually, China with 133,600 and India with 106,210. These three countries are amongst the largest producers of wheat worldwide. The countries with the highest consumption of wheat are China with 131,000 thousand tons, India with 96,725 and Australia using the wheat for feeding their masses of livestock.</p>
                
            </div>

          <div className="commodities-text2">
            <h2>Oil Markets</h2>
            <p>Crude oil is a liquid in the Earth, and it is made of hydrocarbons, organic compounds, and tiny amounts of metal. There are many types of crude produced around the world, and the quality of each is reflected in the value. One of its quality characteristics is the sulfur content1, which can be defined as sweet or sour, and density ranges from heavy to light. If crudes are light and sweet, there are more expensive as opposed to energy products such as diesel and gasoline. There is a high demand for these grades since they can be processed with refineries requiring less energy.</p><br/><br/>
            <p>Many types of crude oil differ in their consistency and density, depending on how and where it is extracted. There are over 160 types of crude oil traded on the market, but Brent Crude and WTI serve the most as the oil benchmarks in the global markets. The WTI oil is taken from Wells in the United States and sent to Oklahoma by pipeline. It is mostly referred to as US crude, and it has expensive shipping costs when there is demand around the world. The WTI oil is very sweet and light, making it ideal for gasoline refining. WTI is a higher quality crude than Brent, and it is always priced at a premium.</p><br/><br/>
            <p>The Organization of the Petroleum Exporting Countries (OPEC) is a cartel of 14 major oil-producing nations seeking to manage the supply of the commodity to control its prices. When there is a meeting on whether to boost or cut production, it can impact current and future prices directly, and oil watchers globally closely follow the announcements. Another important factor affecting the prices is the major crude reports from the US inventory number as higher inventories will mean less demand from the international markets and will pressure the prices lower. Political factors or wars in oil-producing nations are a major issue in the oil markets and natural disasters such as hurricanes that affect major oil infrastructures.</p><br/><br/>
            <h2>Coffee Markets</h2>
            <p>Coffee has become one οf the world’s most profitable commodities. By the 18th century, its cοnsumptiοn and popularity increased significantly in the US during the Civil war. Arabica and Robusta are two different coffee varieties. Arabica is considered a more flavourful bean, with less caffeine and is premium attracting a higher market price. Robusta contains more caffeine and has a bitter taste. Trend followers like to trade Robusta due to its volatility, and traders who prefer more stability choose Arabica.</p><br/><br/>
            <p>The price of coffee can be affected by factors such as changing weather conditions, distribution costs, geopolitics, global health issues and the strength of the US dollar. Also, the price of coffee is moved by factors that relate to supply and demand. Major coffee chains in China increased the price of beverages amid rising costs and inflation. Luckin Coffee, Starbucks and Tim Hortons raised prices by between 1 yuan ($0.16) and 3 yuan ($0.47) according to mobile apps and online menus. Starbucks operates more than 5,500 stores in China and after its first-quarter reporting in February 2022, cautioned that rising inflation and staff shortages continued to present a challenging trading environment globally.</p>
            
          </div>
      </section>
      </div>

      <div id="strong" className="commodities">
      <h2 id="Commodities">Types of Commodities</h2>
      <section  id="strong"className="commodities-why-trade">
        
        <div id="commtext" className="commodities-text1">
            <p>Commodities are raw materials or agricultural outputs that appear naturally, and are used in the production of other goods. They are recognised as the building blocks of the global economy and play a significant role in financial markets</p><br/><br/>
            <p><strong>There are two types of commodities</strong></p>
            <p> <strong>Hard commodities:</strong>  Refers to natural resources that are mined or extracted</p><br/>
            <p>  <strong>Soft commodities:</strong> Agricultural products or livestock</p>
        </div>

        <div id="commtext" className="commodities-text2">
         <p>For the purposes of trading, Commodities are further classified into four main categories:</p><br/><br/>
         <p> <strong> Metals:</strong> Includes precious metals such as gold, silver, platinum, palladium and copper</p><br/>
         <p> <strong>Energy:</strong> Crude oil and natural gas are the main energy products that are traded. Heating oil, gasoline and electricity are among others</p><br/>
         <p>  <strong>Agriculture:</strong> Agricultural commodities are centred around staple crops and animals. Wheat, rice, corn, soybeans coffee are among the most common crops. The classification of animals includes livestock and meat such as live cattle, pork, and eggs.</p><br/>
         <p>  <strong>Livestock and Meat:</strong> Eggs, Pork, Cattle and more</p>
        </div>
    </section>
    </div>


    <div id="strong11" className="commodities">
      <h2 id="Commodities">What Are the Most Traded Commodities?</h2>
      <section  id="strong11"className="commodities-why-trade">
        
        <div className="commodities-text1">
            <p>The most traded Commodities are those which have an established market of buyers and sellers. This translates to high levels of liquidity and lower trading costs – two of the main attractions when trading Commodities CFDs.</p><br/>
            <p><strong>Gold:</strong> Of the precious metals, gold continues to lead the way. Throughout history, gold has been a valuable commodity. The gold standard was in operation for almost a century and central banks continue to hold gold reserves. It is easily transferable for cash and often used as part of a hedging trading strategy as it often trades opposite to the United States dollar (USD).</p>
        </div>

        <div className="commodities-text2">
           <p>Other Metals: Silver, platinum and palladium are among the most traded commodities. As they are considered a safe-haven investment, there is a wide range of Trading Strategies Using Precious Metals.</p><br/><br/>
           <p>Crude Oil: The widespread use of oil makes it one of the most in-demand commodities. Petrol and diesel are examples of refined oil which highlights its importance in all forms of transportation. Its value as a source of energy is the reason why oil prices are heavily scrutinised.</p>

        </div>
    </section>
    </div>


        
<br/><br/><br/><br/><br/><br/>

      {/* What is Forex Trading */}
      <section id="trade11" className="comm-what-is">
        <h2>How to Trade Commodities?</h2>
        {/* <br/> */}
        <p>
        There are several ways to trade commodities such as precious metals and oil. As they are a physical product, investors have the option of purchasing precious metals such as gold, silver and palladium. One of the main hurdles of doing so is the cost associated with storing such a valuable product.</p><br/>
        <p>This is one of the reasons why commodity futures trading emerged. Through exchange-traded funds (ETFs), you are able to enter into an agreement to buy or sell shares of an underlying ETF at an agreed price prior to a specified date. Many large corporations use futures markets to hedge against market volatility.</p><br/>
        <p>Extrede offer CFD trading in commodities where you do not own the underlying asset and enter into a contract which, unlike futures contracts, do not have a specified end date. Trading Gold CFDs allows you to hedge against high risk market conditions using your margin trading account. Similarly, gold is also traded against major currencies in Forex Trading.</p>
      </section>

     
    </div>
  );
};

export default CommoditiesTrading;